import React, { createContext, useContext, useState } from 'react';

const ContactsContext = createContext();

export const useContacts = () => {
  const context = useContext(ContactsContext);
  if (!context) {
    throw new Error('useContacts must be used within a ContactsProvider');
  }
  return context;
};

export const ContactsProvider = ({ children }) => {
  const [contactsStats, setContactsStats] = useState({
    total: 0,
    general: 0,
    premium: 0,
    vip: 0,
    active: 0,
    loading: false
  });

  const updateContactsStats = (stats) => {
    setContactsStats(prev => ({
      ...prev,
      ...stats
    }));
  };

  const value = {
    contactsStats,
    updateContactsStats,
    setContactsStats
  };

  return (
    <ContactsContext.Provider value={value}>
      {children}
    </ContactsContext.Provider>
  );
};

export default ContactsContext;
